import * as React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';
import { Typography } from '@mui/material';
import { theme } from '../../../theme/theme';
import ModalDialogAction from './ModalDialogAction';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { errorStatusSaveHierarchy } from '../../../constants/constant';

function SaveHierarchyModal(props) {
	const [hierarchyName, setHierarchyName] = React.useState('');
	const [error, setError] = React.useState('NO_ERROR');
	const { openModal, onClose, onSave, savedHierachy } = props;
	const [open, setOpen] = React.useState(openModal);
	const handleClose = () => {
		setOpen(false);
		onClose();
	};

	const textStyle = {
		fontFamily: 'Bogle',
		fontSize: '14px',
		fontStyle: 'normal',
		fontWeight: 400,
		lineHeight: '24px',
	};

	const handleOnNameChange = (event) => {
		const name = event.target.value;
		setHierarchyName(name);

		if (name.length > 255 || savedHierachy?.includes(name)) {
			if (name.length > 255) {
				setError('LENGTH_EXCEEDED');
			} else {
				setError('NAME_EXIST');
			}
		} else setError('NO_ERROR');
	};

	const handleSave = (isDefault) => {
		onSave(isDefault, hierarchyName);
		setOpen(false);
	};

	return (
		<ThemeProvider theme={theme}>
			<Dialog
				onClose={handleClose}
				aria-labelledby="customized-dialog"
				open={open}
				fullWidth
				slotProps={{
					backdrop: {
						style: { backgroundColor: 'rgba(255, 255, 255, 0.7)' },
					},
				}}
				sx={{
					'& .MuiDialog-container': {
						'& .MuiPaper-root': {
							width: '100%',
							maxWidth: '800px', // Set your width here
							padding: '24px',
							borderRadius: '8px',
						},
					},
				}}>
				<Box
					sx={{
						display: 'flex',
						alignContent: 'space-between',
						width: '100%',
						padding: 0,
						alignItems: 'center',
						marginBottom: '20px',
					}}
					id="customized-dialog-title"
					onClose={handleClose}>
					<Box sx={{ width: '100%' }}>
						<Typography
							sx={{
								fontSize: '22px',
								fontWeight: 500,
								color: '#333',
								fontFamily: 'Bogle',
							}}>
							Save your hierarchy
						</Typography>
					</Box>
					<IconButton aria-label="close" onClick={handleClose}>
						<CloseIcon sx={{ height: '24px', width: '24px' }} />
					</IconButton>
				</Box>
				<DialogContent
					sx={{
						padding: 0,
						marginBottom: '24px',
					}}>
					<DialogContentText
						sx={{
							fontSize: '16px',
							fontWeight: 400,
							color: '#333',
							fontFamily: 'Bogle',
							marginBottom: '20px',
						}}>
						Give a name to this hierarchy.
					</DialogContentText>
					<TextField
						data-testid="save-hierarchy"
						id="name"
						placeholder="Type a name here"
						type="text"
						error={error !== 'NO_ERROR'}
						fullWidth
						value={hierarchyName}
						variant="outlined"
						sx={{
							'& .MuiInputBase-input': {
								color: '#333',
								fontFamily: 'Bogle',
								fontSize: '16px',
								fontStyle: 'normal',
								fontWeight: 400,
								lineHeight: '24px',
							},
						}}
						onChange={handleOnNameChange}
					/>

					<Box
						sx={{
							display: 'flex',
							alignContent: 'space-between',
							width: '100%',
							alignItems: 'center',
						}}>
						<Box
							sx={{
								width: '100%',
								display: 'flex',
								color: error !== 'NO_ERROR' && '#cb2022',
								alignItems: 'center',
								gap: '4px',
							}}>
							{error !== 'NO_ERROR' && (
								<>
									<ErrorOutlineIcon sx={textStyle} />
									<Typography sx={textStyle}>
										{errorStatusSaveHierarchy[error]}
									</Typography>
								</>
							)}
						</Box>
						<Box
							sx={{
								display: 'flex',
								alignItems: 'center',
							}}>
							<Typography
								sx={{
									...textStyle,
									color: error === 'LENGTH_EXCEEDED' ? '#cb2022' : '#333',
								}}>{`${hierarchyName?.length}`}</Typography>
							<Typography
								sx={{
									color: '#333',
									fontFamily: 'Bogle',
									fontSize: '14px',
									fontStyle: 'normal',
									fontWeight: 400,
								}}>{`/255`}</Typography>
						</Box>
					</Box>
				</DialogContent>

				<ModalDialogAction
					handleClose={handleClose}
					handleSave={handleSave}
					isValid={error === 'NO_ERROR' && hierarchyName?.length !== 0}
				/>
			</Dialog>
		</ThemeProvider>
	);
}

SaveHierarchyModal.propTypes = {
	openModal: PropTypes.bool,
	onClose: PropTypes.func,
	onSave: PropTypes.func,
	savedHierachy: PropTypes.arrayOf(PropTypes.string),
};

export default SaveHierarchyModal;
